import React from "react";
import { ImageElement } from "@kontent-ai/gatsby-components";
import { GatsbyImageProps } from "gatsby-plugin-image";
import { graphql } from "gatsby";
import { ImageFragmentFragment } from "../../graphql-types";

type Props = {
  data: ImageFragmentFragment;
} & Omit<GatsbyImageProps, "alt" | "image"> &
  Partial<Pick<HTMLImageElement, "width" | "height">>;

const Image = ({ data, ...rest }: Props) => {
  if (!data?.elements?.image) {
    return null;
  }

  const {
    caption,
    image: {
      value: [image]
    },
    focal_point_x,
    focal_point_y
  } = data.elements;

  if (!image) {
    return null;
  }

  return (
    <ImageElement
      width={image.width}
      height={image.height}
      // @ts-expect-error ImageItem expects required elements that GraphQL considers optional.
      image={{ ...image, image_id: data.id }}
      alt={caption.value || image?.description}
      imgStyle={{
        objectPosition: `${focal_point_x.value || 50}% ${
          focal_point_y.value || 50
        }%`
      }}
      {...rest}
    />
  );
};

export default Image;

export const query = graphql`
  fragment ImageFragment on kontent_item_asset {
    __typename
    id
    elements {
      caption {
        value
      }
      image {
        value {
          url
          description
          width
          height
        }
      }
      focal_point_x {
        value
      }
      focal_point_y {
        value
      }
    }
  }
`;
